import { render, staticRenderFns } from "./SuggestionMouvement.vue?vue&type=template&id=1a69430e&"
import script from "./SuggestionMouvement.vue?vue&type=script&lang=js&"
export * from "./SuggestionMouvement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports